export default __webpack_public_path__ + "static/media/frightDown.ce40932a.png";